// return the user data from the local storage
import jwtDecode from 'jwt-decode';

const Token = () => {
  const token = localStorage.getItem('token');
  if (token) {
    const decoded = jwtDecode(token);
    const { name, last_name } = decoded;
    const data = {
      user: `${name} ${last_name}`,
      activeToken: token,
    };
    const tokenExp = decoded.exp;
    const time = new Date().getTime() / 1000;
    if (tokenExp < time) {
      localStorage.removeItem('token');
      return false;
    }
    return data;
  }
  return false;
};

export default Token;
